import React, { useEffect, useState } from 'react';

import iconClose from 'assets/images/icon-close.svg';
import iconPrev from 'assets/images/icon-prev.svg';
import iconNext from 'assets/images/icon-next.svg';
import iconCheck from 'assets/images/icon-check.svg';
// import icon from '';

import moment from 'moment';

import { getAvailableTime, createReservation } from 'apis/mainApi';

function ReservationModal({ isPopupOpen, setIsPopupOpen }) {
  const [step, setStep] = useState(1); // 예약 단계 state

  // 모달 생성 시 본문 스크롤을 금지
  useEffect(() => {
    document.body.style.cssText = `position: fixed; top: -${window.scrollY}px;`;
    return () => {
      const scrollY = document.body.style.top;
      document.body.style.cssText = `posotion: ""; top: "";`;
      window.scrollTo(0, parseInt(scrollY || '0') * -1);
    };
  }, []);

  // step 1
  const [getMoment, setMoment] = useState(moment());
  const today = getMoment;
  const firstWeek = today.clone().startOf('month').week();
  const lastWeek =
    today.clone().endOf('month').week() === 1
      ? 53
      : today.clone().endOf('month').week();
  const [selectedDay, setSelectedDay] = useState(today);
  const [selectedTime, setSelectedTime] = useState(null);
  const [disabledTime, setDisabledTime] = useState([]);
  const [availableTime, setAvailableTime] = useState({
    first: true,
    second: true,
    third: true,
  });

  const getAvailableSession = async () => {
    setDisabledTime([]);
    setAvailableTime({
      first: true,
      second: true,
      third: true,
    });
    await getAvailableTime({ selected: selectedDay })
      .then((response) => {
        if (response.data.success) {
          const result = response.data.result;
          setDisabledTime(result);
          if (result.length > 0) {
            const template = {
              first: true,
              second: true,
              third: true,
            };
            result.forEach((element, idx) => {
              if (element.reserved_time === '10:00 - 12:00') {
                template.first = false;
              } else if (element.reserved_time === '13:00 - 15:00') {
                template.second = false;
              } else if (element.reserved_time === '15:00 - 17:00') {
                template.third = false;
              }
            });
            setAvailableTime(template);
          }
        }
      })
      .catch(() => {});
  };

  useEffect(() => {
    if (selectedDay) {
      getAvailableSession();
    }
  }, [selectedDay]);

  // step 2
  const inputTemplate = {
    name: null,
    phone: null,
    reserved_date: null,
    reserved_time: null,
    how_many: null,
    comment: null,
    agreement: false,
  };

  const [inputValues, setInputValues] = useState({ ...inputTemplate });

  // 달력 생성 함수
  const calendarArr = () => {
    let result = [];
    let week = firstWeek;
    for (week; week <= lastWeek; week++) {
      result = result.concat(
        <tr key={week}>
          {Array(7)
            .fill(0)
            .map((data, idx) => {
              let days = today
                .clone()
                .startOf('year')
                .week(week)
                .startOf('week')
                .add(idx, 'day');
              if (days.format('MM') !== today.format('MM')) {
                return <td key={idx} />;
              } else if (days.isBefore(moment().format('YYYYMMDD'))) {
                return (
                  <td className="weekend" key={idx} onClick={() => {}}>
                    <span>{days.format('D')}</span>
                  </td>
                );
              } else {
                return (
                  <td
                    className={
                      selectedDay.format('YYYYMMDD') === days.format('YYYYMMDD')
                        ? 'today'
                        : days.format('dddd') === 'Saturday' ||
                          days.format('dddd') === 'Sunday'
                        ? 'weekend'
                        : ''
                    }
                    key={idx}
                    onClick={() => {
                      if (
                        days.format('dddd') === 'Saturday' ||
                        days.format('dddd') === 'Sunday'
                      ) {
                        return;
                      } else {
                        setSelectedDay(days.clone());
                        setSelectedTime(null);
                        setInputValues({
                          ...setInputValues,
                          reserved_date: days.clone().format('YYYY[-]MM[-]DD'),
                        });
                      }
                    }}
                  >
                    <span>{days.format('D')}</span>
                  </td>
                );
              }
            })}
        </tr>
      );
    }
    return result;
  };

  const firstStep = () => {
    return (
      <section className="step step1">
        <div className="calendar">
          <div className="calendar-top">
            <strong className="month">{today.format('YYYY[년] MM[월]')}</strong>
            <button
              className="arrow prev"
              onClick={() => setMoment(getMoment.clone().subtract(1, 'month'))}
            >
              <img src={iconPrev} alt="" />
            </button>
            <button
              className="arrow next"
              onClick={() => setMoment(getMoment.clone().add(1, 'month'))}
            >
              <img src={iconNext} alt="" />
            </button>
          </div>
          <div className="calendar-table">
            <table cellPadding="0" cellSpacing="0" width="100%">
              <thead>
                <th className="weekend">Sun.</th>
                <th>Mon.</th>
                <th>Tue.</th>
                <th>Wed.</th>
                <th>Thu.</th>
                <th>Fri.</th>
                <th className="weekend">Sat.</th>
              </thead>
              <tbody>{calendarArr()}</tbody>
            </table>
          </div>
        </div>
        <div className="calendar-bottom time">
          <strong className="title">예약가능</strong>
          <div className="check">
            {availableTime.first && (
              <button
                onClick={() => {
                  setSelectedTime('10:00 - 12:00');
                  setInputValues({
                    ...setInputValues,
                    reserved_time: '10:00 - 12:00',
                  });
                }}
                className={
                  selectedTime === '10:00 - 12:00' ? 'selected-time' : ''
                }
              >
                10:00 - 12:00
              </button>
            )}
            {availableTime.second && (
              <button
                onClick={() => {
                  setSelectedTime('13:00 - 15:00');
                  setInputValues({
                    ...setInputValues,
                    reserved_time: '13:00 - 15:00',
                  });
                }}
                className={
                  selectedTime === '13:00 - 15:00' ? 'selected-time' : ''
                }
              >
                13:00 - 15:00
              </button>
            )}
            {availableTime.third && (
              <button
                onClick={() => {
                  setSelectedTime('15:00 - 17:00');
                  setInputValues({
                    ...setInputValues,
                    reserved_time: '15:00 - 17:00',
                  });
                }}
                className={
                  selectedTime === '15:00 - 17:00' ? 'selected-time' : ''
                }
              >
                15:00 - 17:00
              </button>
            )}
          </div>
          {disabledTime.length === 3 && (
            <p className="empty">예약 가능한 시간이 없습니다.</p>
          )}
        </div>
        <div className="calendar-bottom status">
          <strong className="title">예약현황</strong>
          <div className="completed">
            {disabledTime &&
              disabledTime.length > 0 &&
              disabledTime.map((val, idx) => (
                <button key={val.reserved_date + idx}>
                  {val.reserved_time} {val.name}
                </button>
              ))}
          </div>
        </div>
        <div>
          <button
            type="button"
            onClick={() => setStep(2)}
            className="btn"
            disabled={!selectedTime ? true : false}
          >
            확인
          </button>
        </div>
      </section>
    );
  };

  const secondStep = () => {
    return (
      <section className="step step2">
        <div className="calendar">
          <div className="calendar-top">
            <strong className="month">
              {selectedDay.format('YYYY[년] MM[월] DD[일]')}
            </strong>
          </div>
        </div>
        <div className="use-time">
          <p>이용 시간대를 확인해주세요.</p>
          <div className="time-check">
            <img src={iconCheck} alt="" />
            <strong>{selectedTime}</strong>
          </div>
        </div>
        <div className="reservation-form">
          <p>아래의 항목을 입력해주세요.</p>
          <div className="form-wrap">
            <div className="input-wrap">
              <div className="input-style input">
                <input
                  type="text"
                  placeholder="이름"
                  onChange={(e) => {
                    const value = e.target.value;
                    setInputValues({ ...inputValues, name: value });
                  }}
                />
              </div>
              <div className="input-style input">
                <input
                  type="text"
                  placeholder="연락처(숫자만 입력)"
                  value={inputValues.phone}
                  onChange={(e) => {
                    const value = e.target.value;
                    const onlyNumber = value.replace(/[^0-9]/g, '');
                    setInputValues({ ...inputValues, phone: onlyNumber });
                  }}
                />
              </div>
              <div className="input-style select">
                <select
                  defaultValue=""
                  onChange={(e) => {
                    const value = e.target.value;
                    setInputValues({ ...inputValues, how_many: value });
                  }}
                  style={{ appearance: 'none' }}
                >
                  <option value="" disabled>
                    참석인원
                  </option>
                  <option value="1">1명</option>
                  <option value="2">2명</option>
                </select>
              </div>
            </div>
            <div className="input-style textarea-wrap">
              <textarea
                name=""
                id=""
                cols="30"
                rows="3"
                placeholder="이용내용"
                onChange={(e) => {
                  const value = e.target.value;
                  setInputValues({ ...inputValues, comment: value });
                }}
              />
            </div>
          </div>
          <div className="privacy">
            <div className="scroll">
              <p>
                공유디자이너랩 (이하 “회사”)는 이용자의 개인정보를 중요시하며,
                '정보통신망 이용촉진 및 정보보호 등에 관한 법률' 등 관계법령에
                의거하여 개인정보를 관리 및 보호하고 있습니다.
              </p>
              <h3>1. 개인정보의 수집·이용목적</h3>
              <p>
                회사는 수집한 개인정보를 다음의 목적을 위해 이용합니다. 그 외에
                목적으로는 사용되지 않으며, 제 3자에게 제공되지 않습니다.
              </p>
              <h3>2. 수집하는 개인정보 항목</h3>
              <p>
                회사는 예약 문의, 이용 문의 등을 위해 아래와 같은 개인정보를
                수집하고 있습니다.
              </p>
              <ul className="line-list">
                <li>필수항목 : 이름, 연락처, 참석인원</li>
                <li>선택항목 : 이용내용</li>
              </ul>
              <table cellPadding="0" cellSpacing="0" className="table">
                <tbody>
                  <tr>
                    <th>개인정보 수집 항목</th>
                    <th>사유</th>
                  </tr>
                  <tr>
                    <td>이름</td>
                    <td>회사가 문의 예약자를 파악하기 위함</td>
                  </tr>
                  <tr>
                    <td>연락처</td>
                    <td>시설 예약에 대한 안내를 위함</td>
                  </tr>
                  <tr>
                    <td>참석인원</td>
                    <td>시설을 이용하는 인원 파악을 하기 위함</td>
                  </tr>
                  <tr>
                    <td>이용내용</td>
                    <td>시설 이용에 대한 이유를 파악하기 위함</td>
                  </tr>
                </tbody>
              </table>
              <h3>3. 개인정보의 보유 및 이용기간</h3>
              <p>
                원칙적으로 개인정보 수집 및 이용목적이 달성된 후에는
                법정보유기간(5년) 이후에는 해당 정보를 지체 없이 파기합니다.
              </p>
            </div>
            <div className="agree">
              <input
                type="checkbox"
                id="agreement"
                style={{ appearance: 'none' }}
                defaultChecked={inputValues.agreement}
                onClick={(e) =>
                  setInputValues({
                    ...inputValues,
                    agreement: e.target.checked,
                  })
                }
              />
              <label htmlFor="agreement">
                개인정보 수집 및 이용에 대한 동의
              </label>
            </div>
          </div>
          <div className="second-step-bottom-section">
            <button type="button" onClick={() => setStep(1)} className="btn">
              이전
            </button>
            <button
              type="button"
              onClick={() => setStep(3)}
              className="btn"
              disabled={
                !inputValues.name ||
                !inputValues.phone ||
                !inputValues.how_many ||
                !inputValues.comment ||
                !inputValues.agreement
              }
            >
              다음
            </button>
          </div>
        </div>
      </section>
    );
  };

  const handleSubmit = async () => {
    const isConfirmed = window.confirm('예약 하시겠습니까?');
    if (isConfirmed) {
      const comment = inputValues.comment.replace(/(\n|\r\n)/g, '<br>');
      const dataToSubmit = { ...inputValues, comment, reserved_date: selectedDay.format('YYYY[-]MM[-]DD'), reserved_time: selectedTime };
      await createReservation(dataToSubmit)
        .then((response) => {
          if (response.data.success) {
            window.alert('시설 예약을 완료하였습니다.');
            return window.location.replace('/');
          }
        })
        .catch(() => {
          window.alert('예약을 진행할 수 없습니다. 잠시 후 다시 시도해주세요.');
          return;
        });
    }
  };

  const thirdStep = () => {
    const comment = inputValues.comment.replace(/(\n|\r\n)/g, '<br>');
    return (
      <section className="step step3">
        <p>시설 이용 예약 정보를 확인해주세요.</p>
        <dl className="reservation-info">
          <dt className="date">예약일</dt>
          <dd className="date">
            {selectedDay.format('YYYY[년] MM[월] DD[일]')} <br />({selectedTime}
            )
          </dd>
          <dt>이름</dt>
          <dd>{inputValues.name}</dd>
          <dt>연락처</dt>
          <dd>{inputValues.phone}</dd>
          <dt>참석인원</dt>
          <dd>{inputValues.how_many}명</dd>
          <dt>이용내용</dt>
          <dd dangerouslySetInnerHTML={{ __html: comment }} />
        </dl>
        <button type="button" className="btn" onClick={handleSubmit}>
          예약하기
        </button>
        <button
          type="button"
          className="btn return"
          onClick={() => {
            const isConfirmed = window.confirm('처음 부터 다시 작성 하시겠습니까?');
            if (isConfirmed) {
              setSelectedDay(today);
              setSelectedTime(null);
              setInputValues(inputTemplate);
              setStep(1);
            }
          }}
        >
          다시하기
        </button>
      </section>
    );
  };

  return (
    <>
      <main className="popup">
        <section className="popup-wrap">
          <button
            type="button"
            onClick={() => setIsPopupOpen(false)}
            className="close"
          >
            <img src={iconClose} alt="" />
          </button>
          {step === 1 && firstStep()}
          {step === 2 && secondStep()}
          {step === 3 && thirdStep()}
        </section>
      </main>
      <div className="overlay" onClick={() => setIsPopupOpen(false)} />
    </>
  );
}

export default ReservationModal;
